import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  padding: 70px 0 100px 0;

  .legal-container {
    margin-top: 70px;

    .legal-block {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .icon-file {
        font-size: 55px;
        color: ${theme.primaryRed};
      }

      .legal-name {
        margin-top: 18px;
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    padding: 40px 0 60px 0;
  }
`
